/* unplugin-vue-components disabled */import script from "./layout.vue?vue&type=script&setup=true&lang=ts"
export * from "./layout.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__